import { css } from 'lit';

export const styles = css`
  :host(:not(:last-child)) > div:not(.barrel-wrapper-closed) {
    padding-bottom: calc(40em / var(--default-rem-px-count));
  }

  .barrel-wrapper-closed {
    height: calc(60em / var(--default-rem-px-count));
    overflow: hidden;
  }

  .barrel-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-height: calc(60em / var(--default-rem-px-count));
    border-top: 2px solid #222222;
    cursor: pointer;
  }

  .barrel-header span {
    display: flex;
    align-items: center;
  }

  .barrel-heavy-text {
    font-weight: 500;
  }

  .barrel-header-icon {
    display: flex;
    justify-content: right;
    min-height: 2em;
    min-width: 2em;
  }

  .barrel-text {
    padding-bottom: calc(20em / var(--default-rem-px-count));
    line-height: 1.45em;
  }

  /* DOWNLOADS BARREL */
  .downloads-wrapper {
    min-height: calc(30em / var(--default-rem-px-count));
    display: flex;
    align-items: center;
  }
`;
